import React from "react";

/**
 * Reusable "page-hero" band used at the top of interior pages
 * (About, Services, Contact, Career, Blog, Work, etc).
 *
 * Usage:
 *   <PageHero eyebrow="About Kudosta" title="A product-minded software studio...">
 *     We're a compact, senior team...
 *   </PageHero>
 *
 * `children` (or the `description` prop) can be plain text or JSX
 * (e.g. Contact's page-hero embeds a "Start a project" button inline).
 *
 * `eyebrowAs` mirrors the original markup: the service detail pages used a
 * <span> eyebrow (inline, so .eyebrow's margin-bottom does not apply) while
 * the other interior pages used a <div>. Keep the default unless you are
 * matching a service page.
 */
export default function PageHero({ eyebrow, title, description, children, eyebrowAs: Eyebrow = "div" }) {
    return (
        <section className="page-hero container">
            <Eyebrow className="eyebrow">{eyebrow}</Eyebrow>
            <h1 className="h-xl">{title}</h1>
            <p className="lead">{children || description}</p>
        </section>
    );
}
